import { z } from 'zod'

export const domainProductsAttributesSchema = z.object({
  prebidStackEnabled: z.boolean(),
  priceGeniusEnabled: z.boolean(),
  refresherEnabled: z.boolean(),
  unfilledRecoveryEnabled: z.boolean(),
  viewabilityToolsEnabled: z.boolean(),
})

export const domainTableSchema = z.object({
  domainsAttributes: z.record(z.string(), domainProductsAttributesSchema),
})

export type DomainProductsAttributes = z.infer<typeof domainProductsAttributesSchema>
export type DomainTableSchema = z.infer<typeof domainTableSchema>

export const domainTableSchemaDefault: DomainTableSchema = {
  domainsAttributes: {},
}
